import React from 'react';
import '../drawer.css';

class VideoStream extends React.Component {
    constructor (props) {
        super(props);
        this.imageRef = React.createRef();
        this.canvasRef = React.createRef();
        this.videoRef = React.createRef();
    }

    componentDidMount () {
        // const ctx = canvas.getContext("2d");
        // const video = document.getElementById('my-video');
        // const canvas = document.getElementById("myCanvas");
        // try {
        //     this.interval = setInterval(() => {
        //         // 绑定的动态视频
        //         // video.src = `http://${this.props.url}:81/jpg_stream`;
        //         // video.poster = 'https://static.matatalab.com/admin/img/2023-05-23/d9e0fd6da7031be3ed69ef361ad28792.jpg';
        //         // 静态图片 这样的成功过一次
        //         video.poster = `http://${this.props.url}:81/jpg_stream`;
        //         video.autoplay = false;
        //         video.controls = false;
        //         canvas.getContext('2d').drawImage(video, 0, 0, video.width, video.height);
        //         // console.log(video.width, video.height, canvas, 'canvas')
        //     }, 1000);
        // } catch (error) {
        //     console.error(error);
        //     // this.setState({hasError: true});
        // }
        // console.log(video, 'video')
        // this.interval = setInterval(() => {
        //     // this.imageRef.current.src = `http://192.168.0.129:81/stream?t=${new Date().getTime()}`;
        //     this.imageRef.current.src = `http://${this.props.url}:81/jpg_stream`;
        //     // video.src = `http://${this.props.url}:81/jpg_stream`;
        // }, 1000);
        this.imageRef.current.src = `http://${this.props.url}:81/jpg_stream`;
        // this.imageRef.current.style.width = this.props.width
        // this.imageRef.current.style.height = this.props.height
        // 获取dom元素修改img的样式
        setTimeout(() => {
            const iframeDocument = document.querySelector('iframe');
            // 获取iframe下面的img元素失败 iframeDocument.contentWindow.document
            // Uncaught DOMException: Blocked a frame with origin "http://localhost:8601" from accessing a cross-origin frame.

            // 失败原因：由于页面中子iframe嵌套了其他网站的页面，导致了跨域问题，无法获取子iframe的元素和方法。
            // console.log(iframeDocument, iframeDocument.contentWindow.document, '999')
            // let div = iframeDocument.contentDocument || iframeDocument.contentWindow.document
            // console.log(div, 'div')
            // let imgCss = div.getElementsByTagName('img')[0]
            // if (imgCss) {
            //     imgCss.style.width = '100%';
            //     imgCss.style.display = 'block';
            //     imgCss.style.textAlign = 'center'
            //     imgCss.style.height = '143px'
            //     imgCss.style.objectFit = 'cover'
            //     imgCss.style.minHeight = '15vw'
            //     imgCss.style.borderRadius = '16px'
            // }
        }, 2000);
        // video.appendChild(this.imageRef.current);
    }

    componentWillUnmount () {
        clearInterval(this.interval);
        this.imageRef.current.src = ''; // 清除图像的 src 属性，停止请求
    }

    previewStyle () {
        if (this.props.type === 'drawer') {
            return {
                top: '-27px',
                width: '15rem'
            };
        }
        return {
            width: '240px',
            minWidth: '15vw'
        };

    }

    render () {
        return (
            <div
                className="videoCams"
                style={this.previewStyle()}
            >
                <iframe
                    id="videoId"
                    ref={this.imageRef}
                    style={
                        {
                            // textAlign: 'center',
                            // height: '100%',
                            // minWidth: '100%',
                            // objectFit: 'cover',
                            // // minHeight: '15vw',
                            // borderRadius: '16px',
                            // // transform: 'scale(-1, 1)',
                            // position: 'relative',
                            // marginTop: '-27px',
                            // width: '100%'
                        }
                    }
                    // alt="Live Stream"
                />
            </div>

        // <>
        //     <canvas
        //         ref={this.canvasRef}
        //         id="myCanvas"
        //         width="270"
        //         height="142"
        //         style={{ display: 'none' }}
        //     >
        //     </canvas>
        //     <video
        //         type="video/webm"
        //         ref={this.videoRef}
        //         id="my-video"
        //         width='100%'
        //         height='100%'
        //         style={{
        //             textAlign: 'center',
        //             minHeight: '142px',
        //             minWidth: '270px',
        //             objectFit: 'cover',
        //             borderRadius: '5px',
        //             transform: 'scale(-1, 1)',
        //             position: 'relative',
        //             marginTop: '-27px'
        //         }}
        //     >
        //         {/* <source src='https://static.matatalab.com/admin/img/2023-05-23/d9e0fd6da7031be3ed69ef361ad28792.jpg' /> */}
        //     </video>
        // </>
        );
    }
}

export default VideoStream;
